import React from 'react'
import { useDisclosure } from '@chakra-ui/react'
import { useTranslation } from 'next-i18next'
import Dropdown from '_app/components/Dropdown'
import { NotNull, UrlQuery } from '_app/types'
import { Aggregation, AggregationOption } from '_app/types/api'
import Badge from '_app/components/Badge'
import FiltersForm from './FiltersForm'
import { useFilters } from './useFilters'

export interface DropdownLayerFilter extends NotNull<Aggregation> {
  options: NotNull<AggregationOption>[];
}
interface FiltersDropdownProps {
  categoryUid: string;
  activeFilters?: UrlQuery;
}

const FiltersDropdown = ({
  categoryUid,
  activeFilters = {},
}: FiltersDropdownProps) => {
  const { t } = useTranslation()
  const { isOpen, onToggle, onClose } = useDisclosure()
  const filtersHook = useFilters(categoryUid, activeFilters)
  const style = {
    filter: {
      marginRight: '2px',
    }
  }
  return (
    <Dropdown
      isOpen={isOpen}
      onToggle={onToggle}
      onClose={onClose}
      text={
        <Badge hide={filtersHook.activeFiltersCount === 0} value={filtersHook.activeFiltersCount} inline>
          <span style={style.filter}>{t('FILTERS')}</span>
        </Badge>
      }
    >
      {isOpen && (
        <FiltersForm
          {...{
            ...filtersHook,
            onClose,
          }}
        />
      )}
    </Dropdown>
  )
}

export default FiltersDropdown
